import Vue from 'vue';

export default class Footnotes {
  constructor() {
    this.number = 1;
    this.all = [];
  }

  /**
   * Returns a sorted list of all used footnotes
   */
  [Symbol.iterator]() {
    let index = -1;
    const data = this.iterator();

    return {
      next: () => {
        index += 1;
        return {
          value: data[index],
          done: !(index in data),
        };
      },
    };
  }

  add(fn) {
    this.all.push(fn);
  }

  hasItems() {
    return this.all.length;
  }

  /**
   * because of IE11 you need to iterate on this method insteat of the whole object :(
   */
  iterator() {
    return this.all.filter(item => item.number).sort((a, b) => a.number - b.number);
  }

  /**
   * parse text and find all <sup>-tags.
   * replace content with increment number, or first used number.
   *
   * @param text
   * @returns {string}
   */
  parse(text) {
    if (!text) return null;

    const parser = document.createElement('div');
    parser.innerHTML = text;
    const sups = parser.getElementsByTagName('sup');
    Array.from(sups).forEach(sup => {
      const match = this.all.find(fn => fn.prefix === sup.innerText);
      if (match) {
        if (!match.number) {
          Vue.set(match, 'number', this.number);
          this.number += 1;
        }
        sup.innerText = match.number;
        sup.setAttribute('aria-describedby', `fn-${match.number}`);
      } else {
        sup.innerText = '';
      }
    });

    return parser.innerHTML;
  }
}
